angular
    .module('WizApp')
    .service('Collection', [
        function () {
            function Collection(items, builder, uniqueProperty) {
                var self = this;

                self.uniqueProperty = angular.isUndefined(uniqueProperty) ? '_id' : uniqueProperty;
                self.ids = [];
                self.builder = builder || null;

                self.set(items || []);
            }

            Collection.prototype = {
                constructor: Collection,

                build: function (items) {
                    var self = this;

                    if (!angular.isFunction(self.builder)) return items;

                    if (angular.isArray(items)) {
                        angular.forEach(items, function (item, i) {
                            items[i] = self.build(item);
                        });
                    } else {
                        items = new self.builder(items);
                    }

                    return items;
                },

                isIdPicked: function (item) {
                    var self = this;
                    return self.ids.indexOf(item[self.uniqueProperty]) >= 0;
                },

                deduplicate: function (items) {
                    var self = this;

                    if (angular.isArray(items)) {
                        return _.filter(items, function (item) {
                            return Boolean(self.deduplicate(item));
                        });
                    }

                    if (self.isIdPicked(items)) return false;

                    self.ids.push(items[self.uniqueProperty]);
                    return items;
                },

                set: function (items) {
                    var self = this;

                    self.ids = [];
                    self.items = self.build(self.deduplicate(items));

                    return self;
                },

                concat: function (items) {
                    var self = this;

                    self.items = self.items.concat(self.build(self.deduplicate(items)));
                    return self;
                },

                push: function (item) {
                    var self = this;

                    item = self.deduplicate(item);

                    if (item) self.items.push(self.build(item));
                    return self;
                }
            };

            return Collection;
        }
    ])
;
